<template>
    <div class="statistics">
        <div class="text">
            <div class="monitor-header">
                <span>视频监控</span>
                <span @click="close" class="close"><i class="el-icon-close"></i></span>
            </div>
            <div class="monitor">
                <div class="monitorList">
                    <div class="monitorList-title">
                        监控列表
                    </div>
                    <div
                            v-for="(item, index) in tableList"
                            :key="item.id"
                            class="monitorList-subtitle"
                            :style="isActive == index ? 'background:#409EFF;color:#fff' : ''"
                            @click.stop="getInitVideo(item.monitoringUrl,index)"
                    >
                        <span :title="[item.longitude,item.latitude]">{{ item.name }}</span>
                        <img style="width: 24px;height: 24px" src="@/assets/img/carame.png"
                             @click="drawerVideoPoint(item.id)">
                    </div>
                </div>
                <div class="monitorList-area">
                    <div id="myPlayer" class="canvas-img"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EZUIKit from "ezuikit-js";
    import {addAppKey, deviceCameraList, getAppKey, getAppToken, getDevList} from '../api/monitor';
    import {getCameraList, updateLagLat} from "@/api/worker.js";
    import {parseTime} from '@/utils';
    import {getStorage, setStorage, removeStorage} from "@/utils/localStorage";
    import ECesium from "@/views/control/map/util/ECesium";
    import cesiumUtil from "@/utils/cesiumUtils";
    import MapUtil from '@/views/control/map/util/mapUtil';
    import CONSTANTS from "@/views/control/map/constants";

    export default {
        name: "Gaojing",
        data() {
            return {
                list: [],
                drawer: true,
                activeName: "1",
                sum: 0,
                myPlayerIndex: null,
                tableList: [],
                playerList: [],
                isActive: null,
            };
        },
        props: {
            msg: String
        },
        created() {
            this.getListData();
            this.ECesiumTool = new ECesium.Tools(window.gisViewer);
        },
        computed: {},
        mounted() {
            this.getTokenFn();
        },
        methods: {
            //  获取appkey
            getKey() {
                return new Promise(resolve => {
                    getAppKey().then(res => {
                        resolve(res.body.data[0])
                    })
                })
            },
            //  获取appToken
            getToken(params) {
                return new Promise(resolve => {
                    getAppToken(params).then(res => {
                        resolve(res.body.data)
                    })
                })
            },
            //  更新token
            editToken(params) {
                return new Promise(resolve => {
                    addAppKey(params).then(res => {
                        resolve(res)
                    })
                })
            },
            //  获取token
            getTokenFn() {
                let self = this;
                self.getKey().then((res) => {
                    if (res) {
                        const deviceToken = JSON.parse(getStorage("appToken"));
                        if (deviceToken) {
                            if (res.appKey === deviceToken.appKey) {
                                if (deviceToken && deviceToken.accessToken) {
                                    //  如果本地有token但是过期了,需要重新去请求一次
                                    const curDate = new Date().getTime();
                                    const expireDate = new Date(
                                        deviceToken.token_creation_time
                                    ).getTime();
                                    if (curDate > expireDate) {
                                        const {appKey, appSecret, id} = deviceToken;
                                        self.getToken({appKey, appSecret}).then((data) => {
                                            if (data.accessToken) {
                                                const params = {
                                                    appKey,
                                                    appSecret,
                                                    accessToken: data.accessToken,
                                                    token_creation_time: parseTime(data.expireTime),
                                                    id,
                                                };
                                                self.editToken(params).then(() => {
                                                    setStorage("appToken", JSON.stringify(params));
                                                    this.getDeviceList();
                                                });
                                            } else {
                                                self.$store.state.loading = false;
                                                self.$message.error(`请先添加基本信息`);
                                            }
                                        });
                                    } else {
                                        self.getDeviceList();
                                        // console.log(`未过期`)
                                    }
                                } else {
                                    //  如果本地没有token和appk的话,请求一次
                                    self.getKey().then((res) => {
                                        //  使用请求到的appken算,如果没有token的话请求一次,有的话存入使用
                                        if (res) {
                                            if (res.accessToken) {
                                                setStorage("appToken", JSON.stringify(res));
                                            } else {
                                                const {appKey, appSecret, id} = res;
                                                this.getToken({appKey, appSecret}).then((data) => {
                                                    if (data.accessToken) {
                                                        const params = {
                                                            appKey,
                                                            appSecret,
                                                            accessToken: data.accessToken,
                                                            token_creation_time: parseTime(data.expireTime),
                                                            id,
                                                        };
                                                        this.editToken(params).then(() => {
                                                            setStorage("appToken", JSON.stringify(params));
                                                            this.getDeviceList();
                                                        });
                                                    } else {
                                                        this.$store.state.loading = false;
                                                        this.$message.error(data.msg);
                                                    }
                                                });
                                            }
                                        } else {
                                            this.$store.state.loading = false;
                                            // this.$message.error(`没有appKey`)
                                        }
                                    });
                                }
                            } else {
                                if (res.accessToken) {
                                    setStorage("appToken", JSON.stringify(res));
                                } else {
                                    const {appKey, appSecret, id} = res;
                                    self.getToken({appKey, appSecret}).then((data) => {
                                        if (data.accessToken) {
                                            const params = {
                                                appKey,
                                                appSecret,
                                                accessToken: data.accessToken,
                                                token_creation_time: parseTime(data.expireTime),
                                                id,
                                            };
                                            this.editToken(params).then(() => {
                                                setStorage("appToken", JSON.stringify(params));
                                                this.getDeviceList();
                                            });
                                        } else {
                                            this.$store.state.loading = false;
                                            this.$message.error(data.msg);
                                        }
                                    });
                                }
                            }
                        } else {
                            if (res.accessToken) {
                                setStorage("appToken", JSON.stringify(res));
                            } else {
                                const {appKey, appSecret, id} = res;
                                self.getToken({appKey, appSecret}).then((data) => {
                                    if (data.accessToken) {
                                        const params = {
                                            appKey,
                                            appSecret,
                                            accessToken: data.accessToken,
                                            token_creation_time: parseTime(data.expireTime),
                                            id,
                                        };
                                        self.editToken(params).then(() => {
                                            setStorage("appToken", JSON.stringify(params));
                                            this.getDeviceList();
                                        });
                                    } else {
                                        self.$store.state.loading = false;
                                        self.$message.error(data.msg);
                                    }
                                });
                            }
                        }
                    } else {
                        self.$store.state.loading = false;
                        removeStorage("appToken");
                    }
                });
            },
            //  获取设备名称
            getDeviceList() {
                this.$store.state.loading = true;
                getDevList().then(res => {
                    if (res.body.data.length) {
                        res.body.data.map((v, i) => {
                            v.key = 'device';
                            this.getCamera(v, i).then(data => {
                                v.child = data
                            })
                            return v;
                        })
                        setTimeout(() => {
                            this.list = res.body.data;
                            if (this.list.length) {
                                //this.getInitVideo(this.list[0].url,0);
                            }
                        }, 2000)
                    } else {
                        this.$store.state.loading = false;
                    }
                    // console.log(this.list)
                })
            },
            //  获取摄像头
            async getCamera(item, index) {
                let data = await deviceCameraList({id: item.id});
                data.body.data.map(v => {
                    v.childId = v.id + 666 + index;
                    return v;
                })
                setTimeout(() => {
                    this.$store.state.loading = false;
                }, 1000)
                return Promise.resolve(data.body.data);
            },
            close() {
                let self = this;
                self.$parent.dataMonitorShow = false;//关闭列表
            },
            drawerVideoPoint(id) {
                let self = this;
                MapUtil.closeOverlay();
                self.$parent.dataMonitorShow = false;//关闭列表
                self.ECesiumTool.draw('Point', (position) => {
                    let lonlat = cesiumUtil.Cartesian3_to_WGS84(position);
                    MapUtil.closeOverlay();
                    updateLagLat({id: id, longitude: lonlat[0], latitude: lonlat[1]}).then(res => {
                        const result = res.data;
                        if (result.status_code === 100) {
                            self.getListData()
                        }
                        self.$parent.dataMonitorShow = true;//打开列表
                        self.ECesiumTool.deactivate();
                    });
                });
            },
            //  显示监控
            getInitVideo(url, index) {
                this.isActive = index;
                const appToken = JSON.parse(getStorage("appToken"))
                if (appToken) {
                    if (!this.player) {
                        this.player = new EZUIKit.EZUIKitPlayer({
                            autoplay: true,
                            id: 'myPlayer',
                            accessToken: appToken.accessToken,
                            url,
                            splitBasis: 0,
                            template: "simple",
                            // width: 600,
                            // height: 400
                        });
                    }
                    this.player.stop();
                    this.player.opt.url = url;
                    this.player.play();
                } else {
                    // console.log(`暂无token`)
                }
            },
            getListData() {
                let self = this;
                self.cameraLayer = MapUtil.getLayerByName(CONSTANTS.LAYER.CAMERA);//摄像头
                getCameraList(this.curPage, 100).then(res => {
                    const result = res.data;
                    if (result.status_code === 100) {
                        this.tableList = result.data;
                        self.cameraLayer.addEntities(result.data);
                    }
                });
            }
        },
        beforeDestroy() {
            if (this.player) {
                this.player.stop();
                this.player = null;
            }
        }
    };
</script>

<style scoped>
    .statistics {
        width: 100%;
        position: absolute;
        top: 15%;
        left: 30%;
    }

    .text {
        width: 1048px;
        height: 538px;
        color: #fff;
        background: #ffffff;
    }

    .close {
        float: right;
        font-size: 27px;
        margin-right: 15px;
        cursor: pointer;
    }

    .monitor {
        width: 100%;
        margin-top: 10px;
        /*height: calc(100% - 40px);*/
        display: flex;
        flex-wrap: nowrap;
    }

    .monitor-header {
        width: 100%;
        height: 40px;
        text-align: center;
        background: #F4F4F4;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
    }

    .monitorList {
        width: 30%;
        height: 100%;
        overflow: auto;
        margin-right: 25px;
    }

    .monitorList-title {
        background: #E5E5E5;;
        color: #333333;
        height: 30px;
        line-height: 30px;
        margin-top: 1px;
        text-align: center;
        cursor: pointer;
    }

    .monitorList-subtitle {
        color: #333333;
        height: 30px;
        display: flex;
        justify-content: space-between;
        padding: 2px 25px;
        text-align: center;
        align-items: center;
        cursor: pointer;
        border-bottom: 1px solid #e3e3e3;
    }

    .monitorList-area {
        width: 687px;
        height: 458px;
        background: #708090;
    }

    .canvas-img {
        width: 687px;
        height: 458px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
